"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEditReviewDeadline = exports.usePostNewReviewee = exports.useGetCycleDetail = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const CyclesClient_1 = require("client/admin/CyclesClient");
const cycleKeys_1 = __importDefault(require("consts/queryKeys/cycleKeys"));
const useGetCycleDetail = (id, options) => {
    const fetchCycleDetail = () => {
        return (0, CyclesClient_1.getCycle)(id);
    };
    return (0, react_query_1.useQuery)(cycleKeys_1.default.cycle(id), fetchCycleDetail, options);
};
exports.useGetCycleDetail = useGetCycleDetail;
const usePostNewReviewee = (id) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, CyclesClient_1.addNewReviewee)(id, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.usePostNewReviewee = usePostNewReviewee;
const useEditReviewDeadline = (cycleId, placementId) => {
    return (0, react_query_1.useMutation)((body) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield (0, CyclesClient_1.editReviewDeadline)(cycleId, placementId, body);
        if (response === null || response === void 0 ? void 0 : response.isSuccess) {
            return response;
        }
        throw response;
    }));
};
exports.useEditReviewDeadline = useEditReviewDeadline;
